export const CHAT_BOT_TEXT_UTILS = {
  TITLE: "NeumoBot",
  INPUT_LABEL: "Haz una pregunta..."
};

export const CHAT_BOT_ROLES = {
  USER: "user",
  ASSISTANT: "assistant",
  FUNCTION_ROLE: "function"
};

export const CHAT_ACTIONS = {
  OPEN_CHAT: "OPEN_CHAT",
  CLOSE_CHAT: "CLOSE_CHAT",
  START_SPEECH_RECORD: "START_SPEECH",
  STOP_SPEECH_RECORD: "STOP_SPEECH"
};

export const CHAT_ERRORS = {
  ERROR_RESPONSE: "Lo sentimos el chat no se encuentra disponible.",
  ACTION_ERROR: "Lo sentimos esta accion no esta disponible."
};

export const CHAT_MULTIMEDIA_ERRORS = {
  FILE_TOO_LARGE:
    "El archivo es demasiado grande. El límite máximo es de 20 MB por archivo.",
  INVALID_FILE_TYPE:
    "Tipo de archivo no permitido. Solo se admiten imágenes, videos y documentos (PDF, TXT, DOCX, etc.).",
  MAX_FILES_EXCEEDED: "Solo puedes adjuntar hasta 5 archivos a la vez."
};

export const CHAT_MULTIMEDIA_CONFIG = {
  MAX_FILE_SIZE_BYTES: 20 * 1024 * 1024, // 20MB
  MAX_FILES: 5,
  ACCEPTED_FORMATS:
    "image/*,video/*,application/pdf,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,.pdf,.txt,.doc,.docx,.xls,.xlsx,.csv,.json,.xml"
};

export const CHAT_IFRAME_CONFIG = {
  MIN_HEIGHT: 100,
  MAX_HEIGHT: 450,
  DEFAULT_HEIGHT: 180
};

export const CHAT_ACTIONS_RESPONSES = {
  SEARCHING: "searching data",
  NAVEGATING_TO: "navegating",
  NAVIGATION_ERROR_404: "page not found"
};

export const NEWCHAT_EMITED = "newChatMsg";

export const LOGIN_PATH = "/login";

export const CHAT_INIT_MSG =
  "Eres un asistente virtual de la clínica Neumomed, tu objetivo es dar información clara y concisa a los pacientes de la clínica, estas son tus funciones: 1. solo responder a dudas que puedan tener relacionadas a la clínica, información de la misma como formularios, pacientes y citas médicas o con base a las funciones que se están dando en este mensaje. 2. cualquier petición que necesite análisis y/o cálculos con o sin información de la clínica o pacientes. 3. Debes mantener el contexto de la conversación para los pacientes y tener presente siempre la información ya consultada en funciones para resolver dudas antes de realizar nuevas consultas las funciones disponibles. Debes permanecer en este rol y no salirte de este bajo ninguna circunstancia.";
